$(document).ready(function() {
   
  $('.quantityselector .up').click(function(){
  var getinputval = parseInt($(this).prev().val());
  $(this).prev().val(getinputval + 1);
  $('.customcartupdate').click();
  });
  
  $('.quantityselector .down').click(function(){
  var getinputval = parseInt($(this).next().val());
  $(this).next().val(getinputval - 1);
  $('.customcartupdate').click();
  });
  
  
    $('#slidecarthq-cus').show(); 
  
    $('.site-header__cart').on('click', function(){
     	OpenSlideCart();
    });
  
  
  	$('.slidecarthq-cus-overlay').on('click', function(){
        $('.slidecarthq-cus-overlay').removeClass('open');
        $('.slidecarthq-cus').removeClass('open');
      	$('body').removeClass('slidecarthq-open');
    });
  
    $('.footer-continue').on('click', function(){
        $('.slidecarthq-cus-overlay').removeClass('open');
        $('.slidecarthq-cus').removeClass('open');
      	$('body').removeClass('slidecarthq-open');
    });  
  
    $('.close-slider').on('click', function(){
        $('.slidecarthq-cus-overlay').removeClass('open');
        $('.slidecarthq-cus').removeClass('open');
      	$('body').removeClass('slidecarthq-open');
    });
  
    $('.goto-checkout').on('click', function(){
      $(this).addClass('active');
  		GoToCheckout();
    });

  	$(document).on('click', '#slidecarthq-cus .item .remove', function (event) {          
      RemoveItemSlideCart(this);     
  	});
  
   	$(document).on('click', '#slidecarthq-cus .quantity-selector .down', function (event) {     
      MinusSlideCart(this);       
    });
  
    $(document).on('click', '#slidecarthq-cus .quantity-selector .up', function (event) {      
      PlusSlideCart(this);       
    });
    
    $('form[action^="/cart/add"]').on('submit', function(){
      
      event.preventDefault();
      let form = $(this);
      $('body').addClass('addingproduct');
      $.ajax({
        type: "POST",
        url: "/cart/add",
        data: form.serialize(),
        success: function() {                
            let id = form.find('[name=id]').val();
            jQuery.getJSON('/cart.js', function(cart) {                 
              for (key in cart['items']) {
                
                if (cart['items'][key].id && cart['items'][key].id == id) {
                  let curItem = $('#slidecarthq-cus').find('.items').find('[data-variant-id='+id+']')
                  
                  if (curItem.length){
                    let count = curItem.find('[name="quantity-val"]').val();
                    count++
                    curItem.find('[name="quantity-val"]').val(count);                    
                  }else{
                    let addItem = AddSlideCart(cart['items'][key]);
                    $('#slidecarthq-cus').find('.items').append(addItem);
                  }
                  
                  CalculateSlideCart();
                  $('form button.btn-now').removeClass('active');
                  $('body').removeClass('addingproduct');
                  $('.slidecarthq-cus-overlay').addClass('open');
                  $('.slidecarthq-cus').addClass('open');
                }
              }
            });
          }
       })  
    });
  
});

function GoToCheckout() {  
  var getauto = 0;
  $("#slidecarthq-cus .items .item .title a").each(function(){
  var gettitle = $(this).text();
    if(gettitle.indexOf("Auto renew") > -1){
    getauto = 1;
    }
  });
  if(getauto == 1){
     RechargeCartSubmit();
  }else{
  var paramCart = '/a/secure/checkout/eytAfHCFgKM3qZ5Ur8ZW?cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
  window.location = paramCart;
  }
}

function OpenSlideCart() {
  let curItem = $('#slidecarthq-cus').find('.items').find('.item')
  if (!curItem.length){
    $('.slidecarthq-cus').addClass('cart-empty');
  }
   if ($('.slidecarthq-cus-overlay').hasClass('open')) {
     	$('body').removeClass('slidecarthq-open');
        $('.slidecarthq-cus-overlay').removeClass('open');
        $('.slidecarthq-cus').removeClass('open');
      }else{
        $('.slidecarthq-cus-overlay').addClass('open');
        $('.slidecarthq-cus').addClass('open');
        $('body').addClass('slidecarthq-open');
    }

}

function RemoveItemSlideCart(obj) {
   let curItem = $(obj).parents('.item');
   $(obj).parents('.item').toggle( "fast", function() {        
        $(obj).parents('.item').remove();
        CalculateSlideCart();
      });
  UpdateSlideCart(curItem.attr('data-variant-id'),0);
}

function EmptySlideCart(){
  $('.slidecarthq-cus').toggleClass('cart-empty');
}

function CalculateSlideCart(){
  let listBlock = $(document).find('#slidecarthq-cus').find('.items');
  let totalSum = 0;
  let totalCount = 0;
  listBlock.find('.item').each(function( index ) {
    totalSum += parseInt($(this).find('[data-price]').attr('data-price'))/100;
    totalCount += parseInt($(this).find('[name="quantity-val"]').val());
  });
  $('.cart-subtotal__price').find('.sum').html(accounting.formatNumber(totalSum, 2, ",", ".")); 
  
  $('#slidecarthq-cus').find('.cart-count').text(totalCount);
  $('[data-cart-count]').text(totalCount);
  
  if (totalSum == 0 || totalSum < 0) {
    EmptySlideCart();
    $('#slidecarthq-cus').find('.cart-count').text('0');
  }else{
    $('.slidecarthq-cus').removeClass('cart-empty');
  }  
}

function PlusSlideCart(obj){
  let listBlock = $('#slidecarthq-cus').find('.items');
  
  let curVal = parseInt($(obj).parent().find('[name="quantity-val"]').val());
  let curPricePerOne = parseInt($(obj).parents('.main-bottom').find('.sum').text()/curVal);
  curVal++;
  let total = curPricePerOne*curVal;
  
  $(obj).parents('.main-bottom').find('.sum').html(accounting.formatNumber(total, 2, ",", "."));
  $(obj).parents('.main-bottom').find('.price').attr('data-price',total*100);
  $(obj).parent().find('[name="quantity-val"]').val(curVal);      
  
  let curItem = $(obj).parents('.item');
  UpdateSlideCart(curItem.attr('data-variant-id'),curVal);    
  
}

function MinusSlideCart(obj){
  let listBlock = $('#slidecarthq-cus').find('.items');
  let curVal = parseInt($(obj).parent().find('[name="quantity-val"]').val());
  let curPricePerOne = parseInt($(obj).parents('.main-bottom').find('.sum').text()/curVal);
  if (curVal > 1) { 
    curVal--;
    let total = curPricePerOne*curVal;
    
    $(obj).parents('.main-bottom').find('.sum').html(accounting.formatNumber(total, 2, ",", "."));
    $(obj).parents('.main-bottom').find('.price').attr('data-price',total*100);
    $(obj).parent().find('[name="quantity-val"]').val(curVal);       
        
    let curItem = $(obj).parents('.item');
    UpdateSlideCart(curItem.attr('data-variant-id'),curVal);  
  } 
}

function AddUpsellItem(id) {
  let formData = {
    'items': [{
      'id': id,
      'quantity': 1
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((response) => {
    return response.json();
  })
  .then((data) => {
    
    let curItem = $('[data-line-item-id="'+data['items'][0].id+'"]'); 
    if (curItem.length){
      let count = curItem.find('[name="quantity-val"]').val();  
      count++
      curItem.find('[name="quantity-val"]').val(count);                    
    }else{
 		let addItem = AddSlideCart(data['items'][0]);
    	$('#slidecarthq-cus').find('.items').append(addItem);
    }  
    
    CalculateSlideCart();

  })
  .catch((error) => {
    console.error('Error:', error);
  }); 
}

function AddSlideCart(obj) {  

  if (Object.keys(obj).length === 0 ) return;
  
  let price = accounting.formatNumber((obj.original_line_price/100), 2, ",", ".");
  let interval = '';
              
  if (obj.hasOwnProperty("properties") && obj.properties) {
    if (Object.keys(obj.properties).length !== 0 ) {
      if (obj['properties'].hasOwnProperty("shipping_interval_unit_type") && obj['properties'].hasOwnProperty("shipping_interval_frequency")) {
      
      
       interval = `
		<ul class="product-details" data-cart-item-details="" aria-label="Product details">            
            <li class="product-details__item product-details__item--property" data-cart-item-property="">                  
                    <span class="product-details__item-label" data-cart-item-property-name="">Subscribe: Every ${obj['properties']['shipping_interval_frequency']} ${obj['properties']['shipping_interval_unit_type']} </span>
            </li>			
		</ul>`;
      
      }
    }
  }
  let item = `
	          <div class="item" 
               data-line-item-id="${obj.id}" 
			   data-variant-id="${obj.variant_id}" 
               data-line-item-key="${obj.key}">
            <div class="image">
              <a href="${obj.url}">
                <img src="${obj.image}">
              </a>
            </div>
            <div class="main">
              <div class="main-top">
                <div class="main-top-left">
                  <h3 class="title"><a href="${obj.url}">${obj.title}</a></h3>
                </div>
                <button class="remove">
                  <svg width="9" viewBox="0 0 10 10">
                    <path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#cacaca" fill-rule="nonzero"></path>
                  </svg>
                </button>
              </div>
              <div class="prop">
				${interval}
              </div>
              <div class="main-bottom">
                <div class="quantity-selector">
                  <button class="down">
                    <svg width="10" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z" fill="#7A7A7A" fill-rule="nonzero"></path>
                    </svg>
                  </button>
                  <input name="quantity-val" type="text" value="1" min="0" pattern="[0-9]*">
                  <button class="up">
                    <svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path>
                    </svg>
                  </button>
                </div>
                <div class="main-price">
                  <p> <span class="price" data-price="${obj.original_line_price}">$ <span class="sum">${price}</span></span></p>
                </div>
              </div>
            </div>
          </div>`; 

 return  item  
}

function UpdateSlideCart(id,quantity) {

  let formData = {
   'updates': {
     [id]:quantity    
    }
  };

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    
    console.error('Error:', error);
    return '';
  });
  CalculateSlideCart();
}

/*!
 * accounting.js v0.4.2, copyright 2014 Open Exchange Rates, MIT license, http://openexchangerates.github.io/accounting.js
 */
(function(p,z){function q(a){return!!(""===a||a&&a.charCodeAt&&a.substr)}function m(a){return u?u(a):"[object Array]"===v.call(a)}function r(a){return"[object Object]"===v.call(a)}function s(a,b){var d,a=a||{},b=b||{};for(d in b)b.hasOwnProperty(d)&&null==a[d]&&(a[d]=b[d]);return a}function j(a,b,d){var c=[],e,h;if(!a)return c;if(w&&a.map===w)return a.map(b,d);for(e=0,h=a.length;e<h;e++)c[e]=b.call(d,a[e],e,a);return c}function n(a,b){a=Math.round(Math.abs(a));return isNaN(a)?b:a}function x(a){var b=c.settings.currency.format;"function"===typeof a&&(a=a());return q(a)&&a.match("%v")?{pos:a,neg:a.replace("-","").replace("%v","-%v"),zero:a}:!a||!a.pos||!a.pos.match("%v")?!q(b)?b:c.settings.currency.format={pos:b,neg:b.replace("%v","-%v"),zero:b}:a}var c={version:"0.4.1",settings:{currency:{symbol:"$",format:"%s%v",decimal:".",thousand:",",precision:2,grouping:3},number:{precision:0,grouping:3,thousand:",",decimal:"."}}},w=Array.prototype.map,u=Array.isArray,v=Object.prototype.toString,o=c.unformat=c.parse=function(a,b){if(m(a))return j(a,function(a){return o(a,b)});a=a||0;if("number"===typeof a)return a;var b=b||".",c=RegExp("[^0-9-"+b+"]",["g"]),c=parseFloat((""+a).replace(/\((.*)\)/,"-$1").replace(c,"").replace(b,"."));return!isNaN(c)?c:0},y=c.toFixed=function(a,b){var b=n(b,c.settings.number.precision),d=Math.pow(10,b);return(Math.round(c.unformat(a)*d)/d).toFixed(b)},t=c.formatNumber=c.format=function(a,b,d,i){if(m(a))return j(a,function(a){return t(a,b,d,i)});var a=o(a),e=s(r(b)?b:{precision:b,thousand:d,decimal:i},c.settings.number),h=n(e.precision),f=0>a?"-":"",g=parseInt(y(Math.abs(a||0),h),10)+"",l=3<g.length?g.length%3:0;return f+(l?g.substr(0,l)+e.thousand:"")+g.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+e.thousand)+(h?e.decimal+y(Math.abs(a),h).split(".")[1]:"")},A=c.formatMoney=function(a,b,d,i,e,h){if(m(a))return j(a,function(a){return A(a,b,d,i,e,h)});var a=o(a),f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format);return(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal))};c.formatColumn=function(a,b,d,i,e,h){if(!a)return[];var f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format),l=g.pos.indexOf("%s")<g.pos.indexOf("%v")?!0:!1,k=0,a=j(a,function(a){if(m(a))return c.formatColumn(a,f);a=o(a);a=(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal));if(a.length>k)k=a.length;return a});return j(a,function(a){return q(a)&&a.length<k?l?a.replace(f.symbol,f.symbol+Array(k-a.length+1).join(" ")):Array(k-a.length+1).join(" ")+a:a})};if("undefined"!==typeof exports){if("undefined"!==typeof module&&module.exports)exports=module.exports=c;exports.accounting=c}else"function"===typeof define&&define.amd?define([],function(){return c}):(c.noConflict=function(a){return function(){p.accounting=a;c.noConflict=z;return c}}(p.accounting),p.accounting=c)})(this);